/* eslint-disable react/jsx-props-no-spreading */
// DESIGN_SYSTEM_GENERATED_ICONS
import React from 'react';
import Icon from './icons';
function StarHalfFilled(props) {
    return (React.createElement(Icon, Object.assign({ viewBox: "0 0 24 24" }, props),
        React.createElement("path", { fill: "#001325", fillOpacity: ".92", d: "m20.5 9-5.2-.7L13 3.5c-.2-.4-.6-.6-1-.6s-.8.2-1 .6L8.7 8.2 3.5 9c-.9.1-1.3 1.3-.6 2l3.8 3.7-.9 5.2c-.1.7.5 1.3 1.1 1.3.2 0 .381-.032.5-.1l4.6-2.5 4.6 2.4c.2.1.4.1.5.1.7 0 1.2-.6 1.1-1.3l-.9-5.2 3.7-3.7c.8-.7.5-1.8-.5-1.9Zm-4.7 5.1.1.8.8 4.5-4-2.1-.7-.4v-12l2 4 .3.7.8.1 4.5.6-3.8 3.8Z" })));
}
export default StarHalfFilled;
